module.exports = __webpack_public_path__ + "static/img/card.6dab6cda.png";